import { useMemo } from "react";
import { Autocomplete, Checkbox, TextField } from "@mui/material";

export default function OrderActionSelector({ label, selectableActions, onChange, selection }) {

  const options = useMemo(
    () => selectableActions
      .filter(n => n.value != "NONE")
      .map(n => ({
        value: n.value,
        label: n.label
      })),
    [selectableActions]
  );

  const value = selection ?? [];

  return (
    <Autocomplete
      disableCloseOnSelect
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      multiple
      onChange={(_, newValue) => onChange?.(newValue)}
      options={options}
      renderOption={(props, option, { selected }) => (
        <li {...props} >
          <Checkbox
            checked={selected}
            size="small"
            sx={{ p: 0.5, mr: 1 }}
          />
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={value.length === 0 ? "Ingen åtgärd" : ""}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
      sx={{
        "& .MuiAutocomplete-option": {
          minHeight: 30,
          py: 0.25,
        },
      }}
      value={value}
    />
  );
}
